import Vue from 'vue'
import VueRouter from 'vue-router'
import Works from '../views/Works.vue'
import About from '../views/About.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Works,
  },
  {
    path: '/about',
    name: 'about',
    component: About,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
